import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'projectType';

const projectTypeService = {
  getItems: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/data`,
      data,
    });
  },

  getProjectTypeStatus: (projectTypeId) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/${encodeURIComponent(projectTypeId)}`,
    });
  },

  orderProjectType: (id, data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/orderProjectType/${encodeURIComponent(id)}`,
      data,
    });
  },

  updateItem: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },

  createItem: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  deleteData: (data, id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
      data,
    });
  },
};
export default projectTypeService;
